import { createFileRoute, redirect } from "@tanstack/react-router";

/** Legacy path — canonical policy lives at /privacy (matches the OAuth consent screen URL). */
export const Route = createFileRoute("/legal/privacy")({
  beforeLoad: () => {
    throw redirect({ to: "/privacy", replace: true });
  },
});
